import React from 'react'

export default function Home() {
  return (
    <>
    <div className="hero">
        <p className="hero-header text-center mt-4">Atife Design</p>
        <h2 className=" medium text-center c-dark hero-text">Build Responsive Websites <span className='boldest italic'>faster</span> and <span className='boldest italic'>easier</span>!</h2>
        <div className='d-block mt-2'>
            <a href='/quickstart' className="button button-o-dgrey bold"> Quick Start</a>
            <a href='/hero' className="button button-blue bold"> Documentation</a>
        </div>
    </div>  

    <p className='bar-down text-center italic'> Designed by Ajibola Okesola</p>
    </>    
  )
}
